import { Model } from '@shared/models/model';
export class Drawing extends Model {
  constructor() {
    super();
  }
}
